import { Client, ClientFilter } from '@/manager/client/client.model';
import { AcquiredCourses, emptyAcquiredCourses } from '@/manager/client/acquiredCourses.model';
import { ProcedencyInterface } from '@/manager/client/interfaces/procedency.interface';
import { ClientTag } from '@/manager/client/interfaces/tag.interface';

export interface State {
  list: Client[];
  acquiredCoursesList: AcquiredCourses;
  procedencyList: ProcedencyInterface[];
  tagsList: ClientTag[];
  countryList: string[],
  provinceList: string[],
  searchString: string;
  clientPaginationInfo: {};
  genderFilter: ClientFilter;
  locationFilter: ClientFilter;
  procedencyFilter: ClientFilter;
  levelUpDataFilter: ClientFilter;
  curseFilter: ClientFilter;
  conferenceFilter: ClientFilter;
  eventsFilter: ClientFilter;
  tagsFilter: ClientFilter;
  fiscalDataFilter: ClientFilter;
  clientDateFilter: ClientFilter;
  searchFiscalDataExtension: any[];
}

export const state: State = {
  list: [],
  acquiredCoursesList: emptyAcquiredCourses(),
  procedencyList: [],
  tagsList: [],
  countryList: [],
  provinceList: [],
  searchString: '',
  clientPaginationInfo: {},
  genderFilter: new ClientFilter(),
  locationFilter: new ClientFilter(),
  procedencyFilter: new ClientFilter(),
  levelUpDataFilter: new ClientFilter(),
  curseFilter: new ClientFilter(),
  conferenceFilter: new ClientFilter(),
  eventsFilter: new ClientFilter(),
  tagsFilter: new ClientFilter(),
  fiscalDataFilter: new ClientFilter(),
  clientDateFilter: new ClientFilter(),
  searchFiscalDataExtension:[]
};
